import React, { Component } from 'react'

// ui
import Modal from '../../../components/feedback/modal'
import Button from '../../../components/uielements/button'

// redux
import organizationActions from '../../../redux/organization/actions'
import { compose, bindActionCreators } from 'redux'

import { connect } from 'react-redux'
import InfoOrgnai from './info_organization'

class CreateNewEvent extends Component {
    _handleOK = () => {
        const { modalActionCreators } = this.props
        const { hideModalInfo } = modalActionCreators
        hideModalInfo()
    }

    _handleCancel = () => {
        const { modalActionCreators } = this.props
        const { hideModalInfo } = modalActionCreators
        hideModalInfo()
    }

    render() {
        const { showModalInfo } = this.props
        const { currentOrganization, listUserInOrgani } = this.props
        return (
            <Modal
                style={{ top: 20 }}
                visible={showModalInfo}
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                width={600}
                centered={false}
                footer={null}
            >
                <text style={{ color: 'black', fontSize: 20 }}>
                    Thông tin đơn vị
                </text>
                <InfoOrgnai
                    currentOrganization={currentOrganization}
                    listUserInOrgani={listUserInOrgani}
                />
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.currentUser,
        showModalInfo: state.organization.showModalInfo,
        currentOrganization: state.organization.currentOrganization,
        listUserInOrgani: state.organization.listUserInOrgani,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        modalActionCreators: bindActionCreators(
            organizationActions.action,
            dispatch
        ),
        dispatch,
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateNewEvent)
